<template>
  <div class="live-player-wrapper2">
    <div
      class="thumb-image"
      v-if="webcastStatus != 'live' && !webcast.enableVOD"
    >
      <img :src="webcast.thumbUrl" class="webcast-image" alt="webcast-image" />
      <div class="webcast-timing-wrapper">
        <div class="webcast-timing">
          <div v-if="webcastStatus == 'ended'">Livecast has ended</div>
          <div v-if="webcastStatus == 'upcoming'">
            <p>
              {{
                $t("livecast_will_start_in", {
                  time: $moment(webcast.startAt).fromNow(),
                })
              }}
            </p>
            <p style="font-size: 12px">
              {{ webcast.startAt | moment("DD.MM.YYYY @HH:mm") }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="embed-responsive embed-responsive-16by9"
      v-if="webcastStatus == 'live'"
    >
      <div id="player" class="player embed-responsive-item"></div>
    </div>
    <div
      class="embed-responsive embed-responsive-16by9"
      v-if="webcast.enableVOD"
    >
      <iframe
        id="vodPlayer"
        class="player embed-responsive-item"
        :src="stream.vodUrl"
        frameborder="0"
        scrolling="no"
        allowfullscreen
      ></iframe>
    </div>

    <div
      class="under-player-bar"
      v-if="hasStreams || pageSettings.callToActionEnabled"
    >
      <div class v-if="pageSettings.callToActionEnabled">
        <Button
          type="success"
          :to="pageSettings.callToActionLink"
          target="_blank"
          style="float: left; margin-top: 6px; margin-left: 6px"
          >{{ pageSettings.callToActionText }}</Button
        >
      </div>
      <div class v-if="hasStreams">
        <Select
          v-model="selectedStream"
          style="width: 100px; position: absolute; right: 10px; margin-top: 8px"
          placement="bottom-end"
        >
          <Option v-for="s in streams" :value="s._id" :key="s._id">{{
            s.name
          }}</Option>
        </Select>
      </div>
    </div>
  </div>
</template>

<script>
import * as Cookies from 'tiny-cookie'
import Clappr from 'clappr'
import ClapprStats from 'clappr-stats'
import LevelSelector from 'level-selector'
import { mapState, mapGetters, mapActions } from 'vuex'
import feathersClient from '@/api/feathers-client'
import logger from '@/api/logger'

export default {
  data() {
    return {
      player: null,
      selectedStream: null
    }
  },
  props: ['isSidebarCollapsed'],
  computed: {
    ...mapGetters('stream', {
      streamsInStore: 'find',
      getStreamInStore: 'get'
    }),

    ...mapGetters('registrations', {
      registration: 'getCopy'
    }),

    ...mapGetters('session-connections', {
      sessionConnection: 'getCopy'
    }),

    ...mapGetters('page-settings', {
      pageSettings: 'getCopy'
    }),

    ...mapGetters('current', {
      current: 'get'
    }),
    webcast() {
      return this.current('webcast')
    },
    /*
    ...mapGetters("webcast", {
      webcast: "getCopy"
    }),
    */

    webcastStatus() {
      return this.webcast.status
    },
    webcastCurrentSessionId() {
      return this.webcast.currentSessionId
    },
    streams() {
      return this.streamsInStore().data
    },
    hasStreams() {
      //if(this.webcast.status != 'live') return false;
      if (this.streamsInStore().data.length > 1) return true
      else return false
    },
    stream() {
      return this.getStreamInStore(this.$data.selectedStream)
    },
    posterImage() {
      return (
        'https://cdn23.livecasthq.com/transcoderthumbnail?application=platform&streamname=' +
        this.stream.streamId +
        '&size=1280x720&fitmode=letterbox'
      )
    },
    playerUrl() {
      //console.log(this.stream.playerUrl);
      if (this.stream.playerUrl && this.stream.playerUrl != '') {
        return this.stream.playerUrl
      } else {
        //return '//'+this.$store.state.appsettings.copy.playerUrl+'?hlsUrl=//'+this.$store.state.appsettings.copy.hlsUrl+'/'+this.stream.streamId+'/playlist.m3u8'
        return (
          '//' +
          this.$store.state.appsettings.copy.hlsUrl +
          '/ngrp:' +
          this.stream.streamId +
          '_all/playlist.m3u8'
        )
      }
    },
    iframeSrc() {
      return (
        this.playerUrl +
        '&streamId=' +
        this.stream._id +
        '&attId=' +
        this.$data.attId +
        '&sessionId=' +
        this.$store.state.webcast.copy.currentSessionId
      )
    }
  },
  methods: {
    ...mapActions('session-connections', {
      track: 'track'
    }),
    ...mapActions('webcast', {
      getWebcast: 'find'
    }),
    createPlayer() {
      let self = this

      if (this.webcast.status == 'live') {
        this.getWebcast({
          query: {
            shortLink: this.$router.currentRoute.params.shortLink
          }
        }).then(webcast => {
          this.$data.player = new Clappr.Player({
            source: this.playerUrl,
            parentId: '#player',
            Preload: 'metadata',
            width: '100%',
            height: '100%',
            allowUserInteraction: false,
            actualLiveTime: true,
            autoPlay: true,
            maxBufferLength: 1,
            plugins: [ClapprStats, LevelSelector],
            poster: this.posterImage,
            levelSelectorConfig: {
              title: 'Quality',
              labelCallback: function(playbackLevel, customLabel) {
                return playbackLevel.level.height + 'p' // High 720p
              }
            },
            playback: {
              playInline: true
            },
            clapprStats: {
              runEach: 20000,
              onReport: metrics => {
                metrics['isWatching'] = this.$data.player.isPlaying()
                self.track({
                  eventName: 'metrics',
                  data: metrics
                })
              }
            },
            events: {
              onReady: function() {
                self.track({ eventName: 'ready' })
                let container = this.core.activeContainer
                container.seek(container.getDuration())
              },
              onPlay: function() {
                self.track({ eventName: 'play' })
                let container = this.core.activeContainer
              },
              onPause: function() {
                self.track({ eventName: 'pause' })
              },
              onStop: function() {
                self.track({ eventName: 'stop' })
              }
            }
          })
        })
      } else {
      }
    }
  },
  watch: {
    webcastStatus(s) {
      console.log(s)
      if (s != 'live') {
        if (this.player) {
          this.player.stop()
          this.player.destroy()
          this.player = null
        }
      } else {
        this.createPlayer()
      }
    },
    webcastCurrentSessionId(sid) {
      //console.log(sid);
    },
    selectedStream() {
      if (this.player) {
        this.player.stop()
        this.player.destroy()
        this.createPlayer()
      }
    }
  },
  created() {
    if (this.$router.currentRoute.query['streamId']) {
      this.$data.selectedStream = this.$router.currentRoute.query['streamId']
    } else {
      this.$data.selectedStream = this.streamsInStore({
        query: { $limit: 1 }
      }).data[0]._id
    }
    this.createPlayer(Clappr)
  },
  destroyed() {
    if (this.player) {
      this.player.destroy()
      this.player = null
    }
  }
}
</script>

<style lang="less" scoped>
.live-player-wrapper2 {
  width: 100%;
  max-width: 854px;
  margin: auto;
}

.webcast-image {
  width: 100%;
  height: auto;
  display: inherit;
}
.webcast-timing-wrapper {
  bottom: 97px;
  position: relative;
  z-index: 10;
  left: 16px;
  width: fit-content;
  height: 0px;
}
.webcast-timing {
  background-color: #000;
  padding: 15px;
  border-radius: 4px;
  font-size: 14px;
  color: #fff;
}
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.embed-responsive::before {
  display: block;
  content: "";
}
.embed-responsive .embed-responsive-item,
.embed-responsive embed,
.embed-responsive iframe,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.embed-responsive-16by9::before {
  padding-top: 56.25%;
}
#player .container {
  max-width: 100% !important;
}
.under-player-bar {
  height: 48px;
  position: relative;
  background-color: #000;
  @media screen and (max-width: 992px) {
    position: relative;
    width: 100%;
    overflow: visible;
  }

  .ivu-select-selection {
    background-color: #000;
    color: #fff;
  }

  .ivu-select-dropdown {
    background-color: rgb(0, 0, 0);
    color: rgb(255, 255, 255);
  }

  .ivu-select-item-focus {
    background: #222;
  }

  .ivu-select-item {
    color: #ccc;
  }

  .ivu-select-item:hover {
    background: #444;
  }
}
</style>
